import { Overlay, createOverlay } from '@vfde-brix/ws10/overlay';
import { mountComponent } from '../util/mount';
import { HtmlId } from '../enum';

export const mountOverlay = (wrapperId: HtmlId, toggle: (shouldOpen: boolean) => void) =>
    mountComponent(wrapperId, createOverlay, {
        business: {
            onClose: () => toggle(false),
        },
        optPaddingLayout: true,
        optAnimation: 'slide',
    });

export const updateOverlay = (comp: Overlay | null, isOpen: boolean) => {
    isOpen ? comp?.open() : comp?.close();
};
